"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocationIcon = exports.MapPinIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _helpers = require("../helpers");

var _Icon = require("./Icon");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/** MapPinIcon */
var MapPinIcon = function MapPinIcon(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? "Location" : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return /*#__PURE__*/_react.default.createElement(_Icon.Icon, _extends({}, props, {
    viewBox: "0 0 18 18"
  }), /*#__PURE__*/_react.default.createElement(_Icon.Title, null, title), /*#__PURE__*/_react.default.createElement(_Icon.Path, {
    d: "M9.395 16.807a.5.5 0 0 1-.79 0c-3.787-4.85-5.68-8.226-5.68-10.247 0-3.022 2.958-5.68 6.117-5.68 3.196 0 5.934 2.478 5.934 5.62 0 2.121-1.862 5.522-5.581 10.307zM13.975 6.5c0-2.566-2.268-4.62-4.933-4.62-2.63 0-5.118 2.236-5.118 4.68 0 1.65 1.692 4.726 5.075 9.123 3.32-4.34 4.977-7.433 4.977-9.183zM9 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm0 1a3 3 0 1 1 0-6 3 3 0 0 1 0 6z",
    fill: (0, _helpers.color)(props.fill),
    fillRule: "nonzero"
  }));
};

exports.MapPinIcon = MapPinIcon;
MapPinIcon.displayName = "MapPinIcon";
// TODO: remove this alias once clients have been updated

/** LocationIcon */
var LocationIcon = MapPinIcon;
exports.LocationIcon = LocationIcon;
//# sourceMappingURL=MapPinIcon.js.map